import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ImageComponent } from "./components/image/image.component";
import { TextComponent } from "./components/text/text.component";
import { DynamicDirective } from "./components/dynamic/dynamic.directive";
import { DynamicComponentsComponent } from "./containers/dynamic-components/dynamic-components.component";
import { MaterialModule } from "../../../modules/material.module";
import { AppRoutingModule } from "../../../app-routing.module";
import { IncassiInLavorazioneComponent } from "./components/incassi-in-lavorazione/incassi-in-lavorazione.component";
import { IncassiRendicontareComponent } from "./components/incassi-rendicontare/incassi-rendicontare.component";
import { BrogliacciIncassiComponent } from "./components/brogliacci-incassi/brogliacci-incassi.component";
import { LinkComponent } from "./components/link/link.component";
import { IFrameComponent } from "./components/iFrame/iframe.component";
import { ImageWithHtmlComponent } from "./components/image-with-html/image-with-html.component";
import { DocumentsComponent } from "./components/documents/documents.component";
import { AnchorComponent } from "./components/anchor/anchor.component";
import { EmptyComponent } from "./components/empty/empty.component";
import { StructuredDataComponent } from "./components/structured-data/structured-data.component";

import { DashboardService } from "../../../services/dashboard.service";

import { EscapeHtmlPipe } from "../../../pipes/keep-html.pipe";
import { DocumentsExternalSourceComponent } from "./components/documentsExternalSource/documentsExternalSource.component";

@NgModule({
  imports: [CommonModule, MaterialModule, AppRoutingModule],
  declarations: [
    DynamicDirective,
    DynamicComponentsComponent,
    ImageComponent,
    TextComponent,
    IncassiInLavorazioneComponent,
    IncassiRendicontareComponent,
    BrogliacciIncassiComponent,
    LinkComponent,
    IFrameComponent,
    ImageWithHtmlComponent,
    DocumentsComponent,
    AnchorComponent,
    StructuredDataComponent,
    DocumentsExternalSourceComponent,
    EmptyComponent,
    EscapeHtmlPipe,
  ],
  exports: [DynamicComponentsComponent],
  entryComponents: [
    ImageComponent,
    TextComponent,
    IncassiInLavorazioneComponent,
    IncassiRendicontareComponent,
    BrogliacciIncassiComponent,
    LinkComponent,
    IFrameComponent,
    ImageWithHtmlComponent,
    DocumentsComponent,
    AnchorComponent,
    StructuredDataComponent,
    DocumentsExternalSourceComponent,
    EmptyComponent,
  ],
  providers: [DashboardService],
})
export class DynamicComponentsModule {}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/dynamic.module.ts